import { NavLink, useNavigate } from "react-router-dom";
import { authService } from "../services/auth/authService";
import Logo from "../assets/logo-2mm-header.png";
import { User } from "../services/user/userModel";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { cx } from "../react-helpers/css";
import IconGuide from "../assets/icons/icon-guide-white.svg";
import { userService } from "../services/user/userService";
import { loggerBuilder } from "../services/logger";
import { toastsWithIntl } from "../services/toastService";
import { useMemo, useState } from "react";
import { getGuideLink } from "../services/user/userModel";

const CommonHeader = ({
  loggedUser,
  setDisplayMobileMenu,
  hideRecruiterGuide,
}: {
  loggedUser?: User;
  setDisplayMobileMenu?: React.Dispatch<React.SetStateAction<boolean>>;
  /** Free pro accounts do not get the recruiter guide link */
  hideRecruiterGuide?: boolean;
}) => {
  const { logout } = authService();
  const { getPremiumUserLink } = userService();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { toastError } = toastsWithIntl(["common"]);
  const logger = loggerBuilder("CommonHeader");
  const [loadingPremium, setLoadingPremium] = useState(false);
  const recruiterGuideLink = useMemo(
    () => getGuideLink(loggedUser?.usage),
    [loggedUser?.usage],
  );

  return (
    <div className={cx(["header", !!loggedUser?.organizationId && "--pro"])}>
      <NavLink to={"/"}>
        <img className="logo" src={Logo} alt="logo" />
      </NavLink>
      <div className="lrow">
        <div className="header_nav">
          <LanguageSwitcher />
          {loggedUser && !loggedUser.organizationId && (
            <a
              className="header_btn"
              href={t("candidate:CANDIDATE_GUIDE_LINK")}
              target="_blank"
              rel="noreferrer"
            >
              <img src={IconGuide} alt="guide" className="icon" />
              {t("common:header.TIPS")}
            </a>
          )}

          {/* TODO better mechanism for responsive menu */}
          {!!loggedUser?.organizationId && (
            <div className="header_nav --toggle-responsive-menu">
              <button
                className="btn--icon --menu --simple"
                onClick={() => setDisplayMobileMenu?.((prev) => !prev)}
              />
            </div>
          )}

          {!!loggedUser && (
            <>
              {loggedUser.organizationId && !hideRecruiterGuide && (
                <a
                  className="header_btn"
                  href={recruiterGuideLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={IconGuide} alt="guide" className="icon" />
                  <span>{t("common:header.RECRUITER_GUIDE")}</span>
                </a>
              )}
              {!loggedUser.organizationId && (
                <NavLink className="link" to={"/account"}>
                  {t("common:header.MY_ACCOUNT")}
                </NavLink>
              )}
              {!loggedUser.organizationId &&
                (!loggedUser.subscriptionEndDate ||
                  (loggedUser.subscriptionEndDate &&
                    new Date(loggedUser.subscriptionEndDate) < new Date())) && (
                  <button
                    className="header_btn"
                    style={{ background: "black" }}
                    disabled={loadingPremium}
                    onClick={() => {
                      const handlePremiumClick = async () => {
                        try {
                          setLoadingPremium(true);
                          const result = await getPremiumUserLink(
                            loggedUser.id,
                          );
                          if (result?.url) window.location.href = result.url;
                        } catch (err) {
                          logger.error(
                            "Erreur lors de la récupération du lien premium",
                            err,
                          );
                          toastError("common:error.header.PREMIUM_LINK_ERROR");
                          return;
                        } finally {
                          setLoadingPremium(false);
                        }
                      };

                      void handlePremiumClick();
                    }}
                  >
                    ⚡{loadingPremium ? "..." : t("common:header.PREMIUM")}
                  </button>
                )}
              <button
                className="btn--icon --simple --logout"
                onClick={() => {
                  logout().then(
                    () => {
                      navigate("/");
                    },
                    () => {
                      //do nothing
                    },
                  );
                }}
              />
            </>
          )}

          {!loggedUser && (
            <>
              <NavLink className="link" to="/login">
                {t("common:header.LOGIN")}
              </NavLink>
              <NavLink className="link" to="/register">
                {t("common:header.REGISTER")}
              </NavLink>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonHeader;
